import { ModelBase } from 'store/model-base';
import { CmsQuickpayBreadcrumbs } from './quickpay-breadcrumbs';

export class CmsAgentQuickpay extends ModelBase {
    public static storeName: string = 'cmsAgentQuickpay';

    public start: CmsQuickpayStart;
    public summary: CmsQuickpaySummary;
    public card: CmsQuickpayCard;
    public amount: CmsQuickpayAmount;
    public success: CmsQuickPaySuccess;
    public review: CmsQuickpayReview;
    public breadcrumb: CmsQuickpayBreadcrumbs;
}
